import { Action } from 'redux'
import { UserObjectActions } from '../../reducers/userObject/actionNames'

export const changeUserObjectId = (id: number): IChangeObjectID => ({
  id,
  type: UserObjectActions.ChangeUserObjectId,
})

export interface IChangeObjectID
  extends Action<UserObjectActions.ChangeUserObjectId> {
  id: number
}
